import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { NAV_ITEMS, MOBILE_TAB_PATHS } from './navItems';

// Barre d'onglets mobile (< lg) : 4 pages + « Plus » qui ouvre la feuille listant
// tout le reste. Les 4 pages sont celles de la personne : les onglets par défaut
// si elle y a accès, sinon les premières pages qui lui sont permises (une
// gestionnaire recouvrement voit Recouvrement, Clients, GRC… pas Sales Planning).

const PAR_DEFAUT = MOBILE_TAB_PATHS.map((path) => NAV_ITEMS.find((n) => n.path === path));
const ongletsDe = (canSee, permitted) => {
  // Accès restreint : l'ordre des pages permises (la première est le métier de la personne).
  if (Array.isArray(permitted) && permitted.length) {
    return permitted.map((path) => NAV_ITEMS.find((n) => n.path === path)).filter((n) => n && canSee(n)).slice(0, 4);
  }
  const defaut = PAR_DEFAUT.filter(canSee);
  if (defaut.length >= 3) return defaut.slice(0, 4);
  const autres = NAV_ITEMS.filter((n) => canSee(n) && !defaut.includes(n));
  return [...defaut, ...autres].slice(0, 4);
};
const COURT = { '/grc': 'GRC', '/renouvellements': 'Renew', '/recouvrement': 'Recouvr.', '/service-client': 'Service', '/production': 'Prod', '/clients': 'Clients' };

function Tab({ active, icon: Icon, label }) {
  return (
    <>
      <span className={`w-9 h-6 rounded-lg flex items-center justify-center ${active ? 'bg-primary-soft text-primary-text' : ''}`}>
        <Icon className="w-[18px] h-[18px]" strokeWidth={2} aria-hidden="true" />
      </span>
      <span className="text-[11px] font-bold leading-none">{label}</span>
    </>
  );
}

export default function MobileTabBar({ onMore, moreActive = false, canSee = () => true, permitted = null }) {
  const location = useLocation();
  const tabs = ongletsDe(canSee, permitted);
  const itemClass = 'flex flex-col items-center justify-center gap-1 appui';

  return (
    <nav
      className="mobile-tab-bar lg:hidden fixed bottom-0 inset-x-0 z-40 bg-card border-t border-border safe-area-pb"
      aria-label="Navigation principale"
    >
      <div className="grid h-16" style={{ gridTemplateColumns: `repeat(${tabs.length + 1}, minmax(0, 1fr))` }}>
        {tabs.map(({ short, label, path, icon }) => {
          const active = location.pathname === path;
          return (
            <Link
              key={path}
              to={path}
              aria-current={active ? 'page' : undefined}
              className={`${itemClass} ${active ? 'text-foreground' : 'text-foreground-secondary'}`}
            >
              <Tab active={active} icon={icon} label={short || COURT[path] || label} />
            </Link>
          );
        })}
        <button
          type="button"
          onClick={onMore}
          aria-label="Plus de pages"
          aria-expanded={moreActive}
          className={`${itemClass} ${moreActive ? 'text-foreground' : 'text-foreground-secondary'}`}
        >
          <Tab active={moreActive} icon={Menu} label="Plus" />
        </button>
      </div>
    </nav>
  );
}
